import React from "react";

class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen } = this.state;
    const videoUrl =
      "https://lqe-assets.learnquraneasily.in/LQE_Video_small.mp4";

    return (
      <div className="tab-pane fade active show col-11 col-lg-10 m-auto video-shadow mt-lg-3">
        {/* <div
          id="SVGwave1BottomSMShape"
          className="svg-preloader position-relative col-lg-10 m-auto"
        > */}
          <div
            className="bg-img-hero bg-img-hero-video text-center "
            style={{
              backgroundImage:
                "url(https://lqe-assets.learnquraneasily.in/1751089962227_IMG-20250627-WA0001.jpg)",
            }}
          >
            {/* Trigger Modal */}
            <button
              onClick={this.openModal}
              className="js-fancybox d-inline-block u-media-player"
              style={{ background: "transparent", border: "none" }}
            >
              <span className="u-media-player__icon u-media-player__icon--lg">
                <span className="fas fa-play u-media-player__icon-inner"></span>
              </span>
            </button>

            {/* <br />
            <h4 className="d-inline-block text-white mb-0">
              Watch Front Video
            </h4> */}
          </div>

          {/* Video Modal */}
          {isOpen && (
            <div className="video-modal-overlay" onClick={this.closeModal}>
              <div
                className="video-modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <button className="close-btn" onClick={this.closeModal}>
                  &times;
                </button>
                <video src={videoUrl} controls autoPlay loop controlsList="nodownload"className="w-100 h-max-80 br-10">
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          )}
        {/* </div> */}
      </div>
    );
  }
}

export default VideoPlayer;
